import toast from "react-hot-toast";
import { toastDefs, toastDefsError } from "../config/toastConfig";

const toastservice = {
    success: (message: string) => {
        toast.success(message, toastDefs);
    },

    error: (message: string) => {
        toast.error(message, toastDefsError);
    }
}

export default toastservice;